import React, { PureComponent } from 'react';
import { browserHistory } from 'react-router';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

class TrackPackage extends PureComponent {
  constructor(props) {
    super(props);

    this.track = this.track.bind(this);

    this.state = {
      trackingNumber: null
    }
  }
  
  track() {
    const { trackingNumber } = this.state;
    if (trackingNumber && trackingNumber.length === 8) {
      // track it!
      browserHistory.push(`/order/${trackingNumber}`);
    }
  }
  render() {
    const { trackingNumber } = this.state;
    return (
      <div>
        <TextField hintText="Enter your Tracking Number" maxLength={8} onChange={({ target }) => this.setState({ trackingNumber: target.value })} />
        <RaisedButton disabled={!trackingNumber || trackingNumber.length !== 8} onClick={this.track} primary style={{ color: '#fff', marginLeft: 10 }}>Track</RaisedButton>
      </div>
    )
  }
}

export default TrackPackage;



// WEBPACK FOOTER //
// ./src/components/TrackPackage/index.js